/**
 * @file app/constants/sports.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Charlie Hay [charlie.hay@cbc.ca]
 */

export const OLYMPICS_LIST = [
    {
        title: "Curling",
        link: "/sports/olympics/winter/curling",
        thumbnail:
            "https://i.cbc.ca/1.5925587.1614139975!/cpImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/cur-scotties-20210220.jpg",
    },
    {
        title: "Figure Skating",
        link: "/sports/olympics/winter/figure-skating",
        thumbnail:
            "https://i.cbc.ca/1.6641908.1667633917!/fileImage/httpImage/image.JPG_gen/derivatives/16x9_620/figureskating-isu.JPG",
    },
    {
        title: "Long Track Speed Skating",
        link: "/sports/olympics/winter/speed-skating",
        thumbnail:
            "https://i.cbc.ca/1.3487226.1457716241!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/gilmore-junio.jpg",
    },
    {
        title: "Short Track Speed Skating",
        link: "/sports/olympics/winter/short-track-speed-skating",
        thumbnail:
            "https://i.cbc.ca/1.6618706.1665970943!/fileImage/httpImage/image.JPG_gen/derivatives/16x9_620/usa-sport.JPG",
    },
    {
        title: "Alpine Skiing",
        link: "/sports/olympics/winter/alpine-skiing",
        thumbnail:
            "https://i.cbc.ca/1.3437058.1454762372!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/germany-alpine-skiing-world-cup.jpg",
    },
    {
        title: "Freestyle Skiing",
        link: "/sports/olympics/winter/freestyle-skiing",
        thumbnail:
            "https://i.cbc.ca/1.6355828.1645132811!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/cassie-sharpe-1371000153.jpg",
    },
    {
        title: "Snowboard",
        link: "/sports/olympics/winter/snowboard",
        thumbnail:
            "https://i.cbc.ca/1.2995310.1426348441!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/lucien-koch.jpg",
    },
    {
        title: "Bobsleigh",
        link: "/sports/olympics/winter/bobsleigh",
        thumbnail:
            "https://i.cbc.ca/1.3352817.1449368769!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/bobsleigh.jpg",
    },
    {
        title: "Luge",
        link: "/sports/olympics/winter/luge",
        thumbnail:
            "https://i.cbc.ca/1.6324326.1642875492!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/walker-tristan-snith-211218-1180.jpg",
    },
    {
        title: "Skeleton",
        link: "/sports/olympics/winter/skeleton",
        thumbnail:
            "https://i.cbc.ca/1.6314828.1642164082!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/1236662906.jpg",
    },
    {
        title: "Athletics",
        link: "/sports/olympics/summer/athletics",
        thumbnail:
            "https://i.cbc.ca/1.3723159.1471481659!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/degrasse-andre-160816-1180.jpg",
    },
    {
        title: "Aquatics",
        thumbnail:
            "https://i.cbc.ca/1.6538145.1659381923!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/summer-mcintosh-01082022.jpg",
        link: "/sports/olympics/summer/aquatics",
    },
    {
        title: "Rugby",
        link: "/sports/rugby",
        thumbnail:
            "https://i.cbc.ca/1.5605917.1591796857!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/oly-rgu-sevens-draw-20160628.jpg",
    },
    {
        title: "Cycling",
        link: "/sports/olympics/summer/cycling",
        thumbnail:
            "https://i.cbc.ca/1.4273724.1504405368!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/netherlands-cycling-road-world-championship.jpg",
    },
    {
        title: "Volleyball",
        link: "/sports/olympics/summer/volleyball",
        thumbnail:
            "https://i.cbc.ca/1.4203718.1499973037!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/naig-volleyball-live-stream.jpg",
    },
    {
        title: "Gymnastics",
        link: "/sports/olympics/summer/gymnastics",
        thumbnail:
            "https://i.cbc.ca/1.6464835.1653449927!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/ellie-black-030821.jpg",
    },
];

export const SPORTS_LIST = [
    {
        title: "Olympics",
        link: "/sports/olympics",
        thumbnail:
            "https://i.cbc.ca/1.6662434.1669252519!/fileImage/httpImage/image.jpeg_gen/derivatives/16x9_620/cbc-sports-key-art-branding-hybrid.jpeg",
    },
    {
        title: "Paralympics",
        link: "/sports/paralympics",
        thumbnail:
            "https://i.cbc.ca/1.7260532.1725028044!/fileImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/1337984198.jpg",
    },
    {
        title: "Hockey",
        thumbnail:
            "https://i.cbc.ca/1.5925585.1614139764!/cpImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/hkn-oilers-jets-20210217.jpg",
        link: "/sports/hockey",
    },
    {
        title: "Curling",
        link: "/sports/olympics/winter/curling",
        thumbnail:
            "https://i.cbc.ca/1.5925587.1614139975!/cpImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/cur-scotties-20210220.jpg",
    },
    {
        title: "Soccer",
        link: "/sports/soccer",
        thumbnail:
            "https://i.cbc.ca/1.6217510.1634690038!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/soc-panama-canada-20211013.jpg",
    },
    {
        title: "Figure Skating",
        link: "/sports/olympics/winter/figure-skating",
        thumbnail:
            "https://i.cbc.ca/1.6641908.1667633917!/fileImage/httpImage/image.JPG_gen/derivatives/16x9_620/figureskating-isu.JPG",
    },
    {
        title: "Long Track Speed Skating",
        link: "/sports/olympics/winter/speed-skating",
        thumbnail:
            "https://i.cbc.ca/1.3487226.1457716241!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/gilmore-junio.jpg",
    },
    {
        title: "Short Track Speed Skating",
        link: "/sports/olympics/winter/short-track-speed-skating",
        thumbnail:
            "https://i.cbc.ca/1.6618706.1665970943!/fileImage/httpImage/image.JPG_gen/derivatives/16x9_620/usa-sport.JPG",
    },
    {
        title: "Alpine Skiing",
        link: "/sports/olympics/winter/alpine-skiing",
        thumbnail:
            "https://i.cbc.ca/1.3437058.1454762372!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/germany-alpine-skiing-world-cup.jpg",
    },
    {
        title: "Freestyle Skiing",
        link: "/sports/olympics/winter/freestyle-skiing",
        thumbnail:
            "https://i.cbc.ca/1.6355828.1645132811!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/cassie-sharpe-1371000153.jpg",
    },
    {
        title: "Snowboard",
        link: "/sports/olympics/winter/snowboard",
        thumbnail:
            "https://i.cbc.ca/1.2995310.1426348441!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/lucien-koch.jpg",
    },
    {
        title: "Bobsleigh",
        link: "/sports/olympics/winter/bobsleigh",
        thumbnail:
            "https://i.cbc.ca/1.3352817.1449368769!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/bobsleigh.jpg",
    },
    {
        title: "Luge",
        link: "/sports/olympics/winter/luge",
        thumbnail:
            "https://i.cbc.ca/1.7309386.1725027951!/fileImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/1460255485.jpg",
    },
    {
        title: "Skeleton",
        link: "/sports/olympics/winter/skeleton",
        thumbnail:
            "https://i.cbc.ca/1.6314828.1642164082!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/1236662906.jpg",
    },
    {
        title: "Tennis",
        link: "/sports/tennis",
        thumbnail:
            "https://i.cbc.ca/1.5240764.1565324793!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/ten-rogers-cup-women-20190808.jpg",
    },
    {
        title: "Athletics",
        link: "/sports/olympics/summer/athletics",
        thumbnail:
            "https://i.cbc.ca/1.7290313.1725027971!/fileImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/2166066490.jpg",
    },
    {
        title: "Aquatics",
        thumbnail:
            "https://i.cbc.ca/1.6538145.1659381923!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/summer-mcintosh-01082022.jpg",
        link: "/sports/olympics/summer/aquatics",
    },
    {
        title: "Basketball",
        link: "/sports/basketball",
        thumbnail:
            "https://i.cbc.ca/1.6324093.1642822158!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/image.jpg",
    },
    {
        title: "Football",
        link: "/sports/football",
        thumbnail:
            "https://i.cbc.ca/1.6581764.1663102159!/fileImage/httpImage/image.JPG_gen/derivatives/16x9_620/fbo-cfl-blue-bombers-stampeders-20220730.JPG",
    },
    {
        title: "Baseball",
        link: "/sports/baseball",
        thumbnail:
            "https://i.cbc.ca/1.7309398.1725028267!/fileImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/vladimir-guerrero-jr-2162185826.jpg",
    },
    {
        title: "Rugby",
        link: "/sports/rugby",
        thumbnail:
            "https://i.cbc.ca/1.7309356.1725027163!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/olivia-apps-2163914726.jpg",
    },
    {
        title: "Cycling",
        link: "/sports/olympics/summer/cycling",
        thumbnail:
            "https://i.cbc.ca/1.4273724.1504405368!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/netherlands-cycling-road-world-championship.jpg",
    },
    {
        title: "Volleyball",
        link: "/sports/olympics/summer/volleyball",
        thumbnail:
            "https://i.cbc.ca/1.4203718.1499973037!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/naig-volleyball-live-stream.jpg",
    },
    {
        title: "Gymnastics",
        link: "/sports/olympics/summer/gymnastics",
        thumbnail:
            "https://i.cbc.ca/1.6464835.1653449927!/cpImage/httpImage/image.jpg_gen/derivatives/16x9_620/ellie-black-030821.jpg",
    },
    {
        title: "Golf",
        link: "/sports/golf",
        thumbnail:
            "https://i.cbc.ca/1.5556605.1588711494!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_620/brooke-henderson.jpg",
    },
    {
        title: "Equestrian",
        link: "/sports/equestrian",
        thumbnail:
            "https://i.cbc.ca/1.7309377.1725027501!/fileImage/httpImage/image.jpg_gen/derivatives/16x9tight_620/eryn-ballard-1160285289.jpg",
    },
    {
        title: "Full Shows",
        link: "/sports/shows",
        hideInNav: true,
    },
    {
        title: "CBC Sports Originals",
        link: "/sports/originals",
        hideInNav: true,
    },
    {
        title: "Show Jumping",
        link: "/sports/",
        hideInNav: true,
    },
    {
        title: "Live",
        link: "/sports/",
        hideInNav: true,
    },
    {
        title: "Must Watch",
        link: "/sports/",
        hideInNav: true,
    },
    {
        title: "Highlights",
        link: "/sports/",
        hideInNav: true,
    },
];

export const SCHEDULE_TYPE_LIST = [
    "--SUMMER SPORTS",
    "archery",
    "athletics-general",
    "athletics-decathlon heptathlon",
    "athletics-field",
    "athletics-road",
    "athletics-track",
    "aquatics-general",
    "aquatics-artistic-swimming",
    "aquatics-diving",
    "aquatics-swimming",
    "aquatics-water-polo",
    "badminton",
    "baseball",
    "basketball",
    "basketball-3x3",
    "boxing",
    "breaking",
    "canoe-kayak",
    "climbing",
    "cricket",
    "cycling-general",
    "cycling-bmx",
    "cycling-mountain bike",
    "cycling-road",
    "cycling-track",
    "equestrian-general",
    "equestrian-dressage",
    "equestrian-eventing",
    "equestrian-show jumping",
    "fencing",
    "field hockey",
    "football",
    "golf",
    "gymnastics-general",
    "gymnastics-artistic",
    "gymnastics-rhythmic",
    "gymnastics-trampoline",
    "handball",
    "judo",
    "karate",
    "lacrosse",
    "modern pentathlon",
    "rowing",
    "rugby",
    "sailing",
    "shooting",
    "skateboarding-general",
    "skateboarding-park",
    "skateboarding-street",
    "soccer",
    "softball",
    "surfing",
    "table tennis",
    "taekwondo",
    "tennis",
    "triathlon",
    "volleyball",
    "volleyball-beach",
    "weightlifting",
    "wrestling",
    "--SUMMER PARASPORTS",
    "para archery",
    "para athletics",
    "para badminton",
    "blind football",
    "boccia",
    "para canoe",
    "para cycling",
    "para equestrian",
    "goalball",
    "para judo",
    "para powerlifting",
    "para rowing",
    "shooting para sport",
    "sitting volleyball",
    "para swimming",
    "para table tennis",
    "para taekwondo",
    "para triathlon",
    "wheelchair basketball",
    "wheelchair curling",
    "wheelchair fencing",
    "wheelchair rugby",
    "wheelchair tennis",
    "--WINTER PARASPORTS",
    "para alpine skiing",
    "para biathlon",
    "para cross-country skiing",
    "para ice hockey",
    "para snowboard",
    "wheelchair curling",
    "--WINTER SPORTS",
    "alpine skiing",
    "biathlon",
    "bobsleigh",
    "cross-country skiing",
    "curling",
    "figure skating",
    "freestyle skiing",
    "hockey",
    "icecross downhill",
    "luge",
    "nordic combined",
    "short track speed skating",
    "skeleton",
    "ski jumping",
    "skiing",
    "sliding",
    "speed skating",
    "snowboard",
    "--SHOW FILTERS",
    "calgary stampede",
    "cbc shows",
    "CEBL",
    "CHL",
    "CPL",
    "highlights",
    "hockey night in canada",
    "little league baseball",
    "other sports",
    "PWHL",
    "red bull",
    "cbc sports presents",
    "--EVENT TYPE FILTERS",
    "commonwealth games",
    "north american indigenous games",
    "olympics",
    "paralympics",
    "pan am games",
];

export const SCHEDULE_FORMATTED_TYPE_LIST = SCHEDULE_TYPE_LIST
    // uppercase first char
    .map((it) => it.replace(/^([a-z])/, (m, p1) => p1.toUpperCase()))
    // uppercase first char after space, or dash
    .map((it) =>
        it.replace(
            /([a-z]\s+|-)([a-z])/g,
            (m, p1, p2) => `${p1}${p2.toUpperCase()}`
        )
    );

export const SCHEDULE_TYPE_MAP = SCHEDULE_TYPE_LIST.reduce((acc, type, i) => {
    acc[type] = SCHEDULE_FORMATTED_TYPE_LIST[i];
    return acc;
}, {});

export const SCHEDULE_FORMATTED_MAP = SCHEDULE_TYPE_LIST.reduce(
    (acc, type, i) => {
        acc[SCHEDULE_FORMATTED_TYPE_LIST[i]] = type;
        return acc;
    },
    {}
);
